import React, { Component } from 'react';
import './PvWebcamOverlay.css';
import FaceSvgWrapper from "./FaceSvgWrapper";
import DocumentMask from "./DocumentMask";
import FaceRotrationArrow from "./FaceRotrationArrow";

class PvWebcamOverlay extends Component {

    render() {
        return (
            <div className="PvWebcamOverlay">
                {this.props.DISPLAY_FACE_SVG && <FaceSvgWrapper
                    FACE_SVG_ACCEPTED={this.props.FACE_SVG_ACCEPTED}
                    videoWidth={this.props.videoWidth}
                    videoHeight={this.props.videoHeight}
                />}
                {this.props.DISPLAY_FACE_ROTATION_ARROW && <FaceRotrationArrow 
                directionRight={this.props.faceRotrationArrowDirectionRight}
                />}
                {this.props.DISPLAY_DOCUMENT_MASK && <DocumentMask
                    DOCUMENT_MASK_ACCEPTED={this.props.DOCUMENT_MASK_ACCEPTED}
                    DOCUMENT_MASK_HEIGHT_TO_WIDTH_RATIO={this.props.DOCUMENT_MASK_HEIGHT_TO_WIDTH_RATIO}
                    videoWidth={this.props.videoWidth}
                    videoHeight={this.props.videoHeight} />}
            </div>

        );
    }
}

export default PvWebcamOverlay;